var React = require('react');

function HistoriaIconRombo (props) {
    return React.createElement("svg",props,React.createElement("rect",{"y":"10.6067","width":"15","height":"15","transform":"rotate(-45 0 10.6067)","fill":"#C4C4C4","fillOpacity":"0.8"}));
}

HistoriaIconRombo.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = HistoriaIconRombo;

HistoriaIconRombo.default = HistoriaIconRombo;
